import Modal from "@components/atoms/Modal";
import EditBulkItem from "@components/molecules/BulkListItemComponents/EditBulkItem";
import { StoneType } from "@scenes/bulk-request/Utils";
import { ProductCategory } from "@utils/constants";
import { productNameToTokenCategory } from "@utils/index";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components/native";

const EditBulkItemModal = ({
  item,
  isOpen,
  onClose,
  productType,
  removeFromList,
  saveBulkItemDetails,
  requestType,
  fromRequestModify,
  openRemoveFromBulkPopupId,
  RemoveFromBulkListConfirmPopup,
  fromBulkList,
  stoneType = StoneType.SINGLE_STONES,
}: any) => {
  const { t } = useTranslation();
  const productNameShort = productNameToTokenCategory(
    productType ?? ProductCategory.DIAMOND
  );
  const theme = useTheme();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose(false)}
      paddingLeft={0}
      paddingRight={0}
      paddingBottom={0}
      paddingTop={16}
      type={theme.isMobile ? "sheet" : "popUp"}
      headerBackgroundColor={theme[`${productNameShort}-01`]}
      headerTextColor={theme["core-01"]}
      headerTitle={t("bulkInitScreen.editBulkItem.modal.title.text")}
      size={576}
      enableToastMessage={true}
    >
      <EditBulkItem
        item={item}
        productType={productType}
        requestType={requestType}
        removeFromList={() => removeFromList(item.id)}
        handleEvent={(details: any) =>
          saveBulkItemDetails(item.id, details, false)
        }
        saveBulkItemDetails={saveBulkItemDetails}
        fromRequestModify={fromRequestModify}
        fromBulkList={fromBulkList}
        stoneType={stoneType}
        onClose={onClose}
      />
      <>
        {openRemoveFromBulkPopupId ? (
          <RemoveFromBulkListConfirmPopup id={openRemoveFromBulkPopupId} />
        ) : null}
      </>
    </Modal>
  );
};

export default EditBulkItemModal;
